<template>

  <div>
    <ft-select @input="changeMono($event)" :items="CHOICE_ACTIVE" v-model="liqPayOn" class="pointer">
      <v-chip
          dark
          :color="wsACCENT"
          :style="!liqPayOn ? 'opacity : 0.5' : ''"
          class="px-1 justify-end font-weight-medium pointer"
      >

        <v-icon  class="mr-1" >
          {{  liqPayOn ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
        </v-icon>

        <h5 class="mx-2">{{ liqPayOn ? $t('Active') : $t('NotActive')   }}</h5>

        <v-icon >mdi-menu-down</v-icon>

      </v-chip>
    </ft-select>

    <wsDialog v-if="displayMono"
              v-model="displayMono"
              :title="$t('FondySettings')"
              @save="linkFondy"
              :loading="LOADING"
              :save-text="$t('ConfirmLink')">

      <ws-text-field
          v-model="fondy.account"
          :placeholder="$t('EnterMerchantID')"
          label="Merchant ID"
          dense
          outlined
          hide-details
      />
      <ws-text-field
          class="mt-5"
          v-model="fondy.secret"
          :label="$t('FondySecretKey')"
          :placeholder="$t('EnterFondySecretKey') "
          dense
          outlined
          hide-details
      />

    </wsDialog>

  </div>



</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "liqPaySettings",
  props : {
    value : {
      type : Boolean,
      default : false
    }
  },
  data() {
    return {
      liqPayOn : false,
      displayMono : false,
      fondy : {
        account   : null,
        secret : null
      }
    }
  },
  watch: {
    value() {
      if ( this.value !== this.liqPayOn ) {
        this.liqPayOn = this.value
      }
    }
  },
  methods : {
    ...mapActions('fondy', [
      'LINK_BUSINESS',
      'UNLINK_BUSINESS'
    ]),

    async changeMono(value) {

      if ( !value ) {
        return this.unlinkFondy()
      }

      this.liqPayOn = false
      this.liqPay = {
        public_key   : null,
        private_key  : null,
      }
      this.displayMono = true

    },

    async unlinkFondy() {

      if (await this.UNLINK_BUSINESS() ) {
        this.notify(this.$t('FondyUnlinked'))
        this.$emit('input',false)
        return
      }
    },
    async linkFondy() {

      if (!await this.LINK_BUSINESS(this.fondy) ) {
        return this.notify(this.$t('WrongFondyData'))
      }

      this.$emit('input',true)
      this.notify( this.$t('FondyConnected') )
      this.displayMono = false

    },
  },
  mounted() {
    if ( this.value ) {
      this.liqPayOn = this.value
    }
  }
}
</script>

<style scoped>

</style>